<template>
    <div id="row" class="d-flex flex-column align-items-left">
      <div class="row1 d-flex flex-rows justify-content-between align-items-center">
        <div class="lg1">
          <div class="category">{{category.lg1}}</div>
          <div class="type">{{type.lg1}}</div>
        </div>
        <div class="price float-right d-flex flex-rows justify-content-between align-items-center">
          <div>{{price1}}</div>
          <div>{{price2}}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'IbisRatesHorizontalV1RatesRow',
  props: {
    ratesLg1: Array,
    ratesLg2: Array
  },
  computed: {
    category () {
      return {lg1: this.ratesLg1[0].label_value, lg2: this.ratesLg2 && this.ratesLg2[0].label_value}
    },
    type () {
      return {lg1: this.ratesLg1[0].sub_label, lg2: this.ratesLg2 && this.ratesLg2[0].sub_label}
    },
    price1 () {
      return this.ratesLg1[0].mrr_value
    },
    price2 () {
      let offset = 1
      if (this.ratesLg2) {
        offset = 2
      }
      return this.ratesLg1[offset].mrr_value
    }

  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibis.scss";

#row {
  width: 100%;
  @include heightPercent(149);
  border-top: 1px solid $border;

  .row1 {
    margin-top: 3vh;

    .lg1 {
      max-height: 120 * 100vh / $srcHeight;
      overflow: hidden;

      .category {
        font-family: "Helvetica-Roman";
        @include fontSize(42);
        max-height: 52 * 100vh / $srcHeight;
        max-width: 523 * 160vh / $srcWidth;
        overflow: hidden;
      }

      .type {
        font-family: "Helvetica-Oblique";
        @include fontSize(26);
        max-height: 32 * 100vh / $srcHeight;
        max-width: 964 * 160vh / $srcWidth;
        overflow: hidden;
      }
    }

    .price {
      font-family: "Helvetica-Bold";
      @include fontSize(42);
      color: $red;
      white-space: nowrap;
      margin-top: -2vh;

      div {
        @include widthPercent(209);
        text-align: right;

        &:nth-of-type(2) {
           margin-left: 23 * 160vh / $srcWidth;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v2/rates/rowRates.vue